export const CONFIDENCE_RANGE = [-0.0683122847301952, 1.0683122847301951];
export var MainAxesName;
(function (MainAxesName) {
    MainAxesName["X_AXIS"] = "xaxis";
    MainAxesName["Y_AXIS"] = "yaxis";
})(MainAxesName || (MainAxesName = {}));
export const AXES_REGEXP = new RegExp(/[xy]axis(?:1(?:[0-2])|[2-9])?/);
export const Y_AXES_REGEXP = new RegExp(/[y]axis(?:1(?:[0-2])|[2-9])?/);
export const Z_AXES_REGEXP = new RegExp(/[z]axis(?:1(?:[0-2])|[2-9])?/);
export const DRAGS_REGEXP = new RegExp("(^nsdrag$|^sdrag$|^ndrag$)");
export var RestyleYAxesDirection;
(function (RestyleYAxesDirection) {
    RestyleYAxesDirection["ALL_LEFT"] = "allLeft";
    RestyleYAxesDirection["THREE_LEFT_THREE_RIGHT"] = "threeLeftThreeRight";
})(RestyleYAxesDirection || (RestyleYAxesDirection = {}));
